import script from "./OrganizacaoCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizacaoCadastro.vue?vue&type=script&setup=true&lang=js"

import "./OrganizacaoCadastro.vue?vue&type=style&index=0&id=9d834126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d834126"]])

export default __exports__